// The API supplies only PO options owned by the authenticated customer.
// Public homepage trips must never be used as customer options.
export default function CustomerPoSelector({ options, selectedId, onSelect }) {
    if (!Array.isArray(options) || options.length < 2) return null;
    return (
        <section data-testid="customer-po-selector" aria-label="Pilih PO pesanan" className="mt-4 mb-3">
            <p className="mb-2 text-[11px] font-semibold text-[color:var(--wx-muted)]">Pilih PO</p>
            <div className="grid grid-cols-2 gap-2">
                {options.map((po) => (
                    <button
                        key={po.id}
                        type="button"
                        data-testid={`select-po-${po.id}`}
                        aria-pressed={selectedId === po.id}
                        onClick={() => onSelect(po.id)}
                        className={`min-w-0 rounded-xl border px-3 py-2.5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--wx-blue)] focus-visible:ring-offset-2 ${selectedId === po.id ? "border-[color:var(--wx-blue)] bg-blue-50 text-[color:var(--wx-blue)]" : "border-[color:var(--wx-line)] bg-white text-[color:var(--wx-ink-2)]"}`}
                    >
                        <span className="block text-xs font-semibold leading-snug break-words">{po.name || po.id}</span>
                        <span className="mt-1 block text-[10px] leading-snug text-[color:var(--wx-muted)]">
                            {po.status === "OPEN" ? "Pemesanan dibuka" : ["CLOSED", "CLOSE"].includes(po.status) ? "Pemesanan ditutup" : po.status === "PLANNED" ? "Segera dibuka" : po.status || "Lihat pesanan"}
                        </span>
                    </button>
                ))}
            </div>
        </section>
    );
}
